
// Define the blog post interface
export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string | string[];
  date: string;
  author: string;
  category: string;
  image?: string;
  imageLink?: string;
  tags?: string[];
  readTime?: string;
}

// Categories for blog posts
export const blogCategories = [
  "For begyndere",
  "Teknik og øvelser",
  "Musikforståelse og teori",
  "Inspiration og motivation",
  "Avancerede emner"
];

// Helper function to sort blog posts by date (newest first)
export const sortBlogPostsByDate = (posts: BlogPost[]) => {
  return [...posts].sort((a, b) => {
    // Convert date strings to Date objects for comparison
    const dateA = new Date(a.date.split('.').reverse().join('-'));
    const dateB = new Date(b.date.split('.').reverse().join('-'));
    return dateB.getTime() - dateA.getTime();
  });
};
